import { AccountsCompaniesList } from "@/modules/accounts/AccountsCompaniesList";
import { AccountsPeopleList } from "@/modules/accounts/AccountsPeopleList";
import type { AccountsHubChrome } from "@/modules/accounts/AccountsModuleToolbar";

/**
 * Accounts List — company-first bill-to directory, with a People list for
 * every contact (including people without an account).
 * @see docs/plans/accounts-hub-DESIGN-DECISION.md
 */
export const AccountsGroupedList = ({
  accountsChrome,
}: {
  accountsChrome: AccountsHubChrome;
}) =>
  accountsChrome.listTab === "people" ? (
    <AccountsPeopleList accountsChrome={accountsChrome} />
  ) : (
    <AccountsCompaniesList accountsChrome={accountsChrome} />
  );
